<template>
  <div class="pageBawActive">
    <XR-head titleText="BAW激活" :rightShow="false"></XR-head>    
    <div class="total account-address">
      <p class="title">请激活您的BAW账户，激活后即可使用BAW在旭日购商城消费购物。</p>
      <!-- <mu-divider class="line"></mu-divider> -->
      <!-- <p class="desc">由美国顶尖技术人员历时三年</p> -->
      <mu-raised-button label="激活" @click="submit" primary fullWidth class="activeBtn"></mu-raised-button>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    submit: function() {
      var ths = this;   
      ths.$refs.XRtoast.load("激活中...")
      ths.$post(
        "/Shop/BawServer/MakeBawAccount"
      ).then(function(res) {
        if(!res.IsSuccess){     
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{         
          ths.$refs.XRtoast.hide()
          ths.$router.goBack()
        }
      });
    }
  }
};
</script>
<style>
#app .pageBawActive{
  bottom: 0;
  background: white;
}
.pageBawActive .total{
  background: white;
  padding: 20px 20px;
}
.pageBawActive .title{
  line-height: 24px;
  font-size: 14px;
  color:red;
}
.pageBawActive .line{    
  margin: 10px 0;
}
.pageBawActive .account-address .desc{    
  padding: 10px 0 0;
  font-size: 12px;
  color:#999;
  word-break: break-all;
}
.pageBawActive .activeBtn{    
  height: 50px;
  margin: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/baw/net/bawActive.vue